(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* -------- StickyHeader (unchanged behavior) -------- */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close && d.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* -------- Mega menu on HOVER (desktop only) — no CSS edits -------- */
  (function () {
    const DESKTOP = window.matchMedia('(min-width: 990px)');
    const OPEN_ATTR = 'open';

    // Find ALL <details> that could be menu parents (covers Dawn and many variants)
    function findMenuDetailsNodes() {
      const root = document.querySelector('.header');
      if (!root) return [];
      const candidates = root.querySelectorAll(
        // common spots:
        '.header__inline-menu details,' +        // Dawn inline menu
        'header-menu details,' +                 // <header-menu> web component
        '.menu-drawer__navigation details,' +    // in case header renders an alt container
        'nav details'                            // fallback inside any nav
      );
      // Keep only those that actually contain a submenu/mega content
      return Array.from(candidates).filter(d =>
        d.querySelector('.mega-menu, [data-mega-menu], .header__submenu, [id*="HeaderMenu-"], ul, div[role="menu"]')
      );
    }

    function setExpanded(details, yes) {
      const summary = details.querySelector('summary');
      if (yes) {
        if (!details.hasAttribute(OPEN_ATTR)) details.setAttribute(OPEN_ATTR, '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      } else {
        if (details.hasAttribute(OPEN_ATTR)) details.removeAttribute(OPEN_ATTR);
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }

    function bindHover(details) {
      if (details.__hoverBound) return;
      details.__hoverBound = true;

      let leaveTimer;

      // Open when mouse enters the details OR its summary
      details.addEventListener('mouseenter', () => {
        if (!DESKTOP.matches) return;
        clearTimeout(leaveTimer);
        setExpanded(details, true);
      });

      // Close when mouse leaves the whole details block
      details.addEventListener('mouseleave', () => {
        if (!DESKTOP.matches) return;
        leaveTimer = setTimeout(() => setExpanded(details, false), 120);
      });

      const summary = details.querySelector('summary');

      // Keyboard: focus opens, blur closes (desktop only)
      if (summary) {
        summary.addEventListener('focus', () => { if (DESKTOP.matches) setExpanded(details, true); });
        summary.addEventListener('blur',  () => { if (DESKTOP.matches) setExpanded(details, false); });

        // Prevent native toggle when clicking the summary *itself* on desktop,
        // but allow clicks on nested links inside the summary.
        summary.addEventListener('click', (e) => {
          if (!DESKTOP.matches) return;
          if (e.target === summary) e.preventDefault();
        });
      }
    }

    function apply() {
      const nodes = findMenuDetailsNodes();
      if (DESKTOP.matches) {
        nodes.forEach(bindHover);
      } else {
        // ensure closed on mobile so tap-to-open works normally
        nodes.forEach(d => setExpanded(d, false));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }

    if (DESKTOP.addEventListener) {
      DESKTOP.addEventListener('change', apply);
    } else {
      // Safari < 14
      DESKTOP.addListener(apply);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
